export const FETCH_PROPERTY_CATEGORY_CLASSIFICATIONS = `${process.env.REACT_APP_API_URL}/property-category-classifications`;
